const sections = document.querySelectorAll("section")

const handleSections = (step) => {
  sections.forEach(section => {
    if (section.hasAttribute("data-step")) {
      if (Number(section.getAttribute("data-step")) === Number(step)) {
        section.style.display = "block"
      } else {
        section.style.display = "none"
      }
    }
  })
}

export default handleSections
